export const SPACE_BAR_KEY_CODE = [0, 32];
export const ENTER_KEY_CODE = 13;
export const ESCAPE_KEY_CODE = 27;
export const DOWN_ARROW_KEY_CODE = 40;
